import gql from "graphql-tag";

export default gql`
  query FinancialsAvailability(
    $tickerSymbol: TickerSymbol!
    $country: SecurityCountry!
    $vertical: PlatformVertical!
    $indicatorDataSource: IndicatorDataSource!
  ) {
    financialsAvailability(
      tickerSymbol: $tickerSymbol
      country: $country
      vertical: $vertical
      indicatorDataSource: $indicatorDataSource
    ) {
      statementType
      reportDates
      viewerCanSee
    }
  }
`;
